
  <section class="page-banner-sec" style="background-image: url(assets/img/contact-page-banner.png);">
    <div class="container">
        <h1 class="page-banner-title">Contact Us</h1>
    </div>
  </section>

  <section class="py-5 contact-us-page-sec">
     <div class="container">
         <div class="row align-items-center">
             <div class="col-lg-7 pr-lg-5">
                 <div class="contact-page-img-left">
                    <img class="img-responsive" src="assets/img/contact-img-page.png">
                 </div>
             </div>
             <div class="col-lg-5">
                <div class="contact-page-text-right">
                    <ul class="contact-listt">
                        <!-- <li>
                            <span class="contact-listt-icon">
                                <img src="assets/img/con-telephone-icon.png">
                            </span>
                            <span class="contact-listt-text"> +1 713 587 8963</span> 
                        </li> -->
                        <li>
                            <span class="contact-listt-icon">
                                <img src="assets/img/con-env.png">
                            </span>
                            <span class="contact-listt-text">  info@wooffertechnologies.com</span> 
                        </li>
                        <!-- <li>
                            <span class="contact-listt-icon">
                                <img src="assets/img/con-location.png">
                            </span>
                            <span class="contact-listt-text"> Plot No. D-6, Behind Silvotel,
                                Chicago, USA</span> 
                        </li> -->
                    </ul>
                </div>
            </div>
         </div>
     </div>
  </section>
  
